<template>
	<form @submit.prevent="submit()">
		<fieldset>
			<div>
				<div>
					<legend><span>Confirm Your Account</span></legend>
				</div>
				<div class="input-group">
					<label v-if="!$route.params.code"><span>Code </span>
						<div>
							<div v-if="form.errors.get('code')" class="error-block">
								<p v-html="form.errors.get('code')"></p>
							</div>
							<input v-model="form.data.code" type="text">
						</div>
					</label>
					<label><span>Email </span>
						<div>
							<div v-if="form.errors.get('email')" class="error-block">
								<p v-html="form.errors.get('email')"></p>
							</div>
							<input v-model="form.data.email" type="email">
						</div>
					</label>
					<label><span>Password </span>
						<div>
							<div v-if="form.errors.get('password')" class="error-block">
								<p v-html="form.errors.get('password')"></p>
							</div>
							<input v-model="form.data.password" type="password">
						</div>
					</label>
					<label><span>Confirm Password </span>
						<div>
							<div v-if="form.errors.get('password_confirmation')" class="error-block">
								<p v-html="form.errors.get('password_confirmation')"></p>
							</div>
							<input v-model="form.data.password_confirmation" type="password">
						</div>
					</label>
					<label class="checkbox">
						<div v-if="form.errors.get('terms_agreed')" class="error-block">
							<p v-html="form.errors.get('terms_agreed')"></p>
						</div>
						<span>Agree to Terms & Conditions </span>
						<input v-model="form.data.terms_agreed" type="checkbox">
					</label>
				</div>
			</div>
		</fieldset>
		<ul class="actions wide">
			<li>
				<process-button
					:processing="form.processing" class="button button--primary--wide" text="Confirm Account"/>
			</li>
		</ul>
		<ul class="sub-actions">
			<li><router-link :to="{name: 'register.resend-confirmation-email'}">Resend email</router-link></li>
		</ul>
	</form>
</template>
<script>
export default {
	data() {
		return {
			form: this.newForm({
				code: "",
				email: "",
				password: "",
				password_confirmation: "",
				terms_agreed: false,
			}).setHttpClient(http(true)).setStore(),
		};
	},

	props: ["code"],

	methods: {
		async submit() {
			this.form.processing = true;
			await http(true).get("sanctum/csrf-cookie");
			await this.form.post("sign-up/confirm").then(() => {
				this.$router.push({name: "login"});
			}).catch(error => {
				if ("InvalidAccountConfirmationCode" === error.response.data.error) {
					console.log("InvalidAccountConfirmationCode");
					console.log(error.response);
				}
				if ("AccountConfirmationFailed" === error.response.data.error) {
					console.log("AccountConfirmationFailed");
					console.log(error.response);
				}
			});
		},
	},

	created() {
		if (this.$route.params.code) {
			this.form.set("code", this.$route.params.code);
		}
	},
};
</script>
